import { Badge, Separator } from '@commenda/kakashi';

import { StackedDataPoint } from '../../../components';
import { IndirectTaxTransactionHelper } from '../helpers';
import {
  TIndirectTaxTransactionDetail,
  TIndirectTaxTransactionRegion,
} from '../types';
import { IndirectTaxTransactionCustomerSection } from './IndirectTaxTransactionCustomerSection';
import { IndirectTaxFilingsHelper } from '../../filings/helpers';

interface IndirectTaxTransactionDetailSidebarProps {
  transaction: TIndirectTaxTransactionDetail;
  region: TIndirectTaxTransactionRegion;
  onViewCustomer?: () => void;
}

const IndirectTaxTransactionDetailSidebar = ({
  transaction,
  region,
  onViewCustomer,
}: IndirectTaxTransactionDetailSidebarProps) => {
  const showSupplyType =
    IndirectTaxTransactionHelper.shouldShowSupplyType(region);
  const showConversionRate =
    IndirectTaxTransactionHelper.shouldShowConversionRate(
      region,
      transaction.currency,
      transaction.filingCurrency
    );

  const isTaxIncluded = transaction.lineItems.length > 0 ? transaction.lineItems[0].taxIncluded : false;

  return (
    <div className="flex flex-col" data-ai-section="Transaction details">
      <div className="flex flex-col pb-lg">
        <div className="p-3xl pb-lg">
          <span className="txt-extra-large-bold text-text-primary">
            Details
          </span>
        </div>

        <StackedDataPoint label="Transaction date" value={transaction.date} />
        <StackedDataPoint
          label="Transaction type"
          value={
            <Badge variant={IndirectTaxTransactionHelper.getTransactionTypeBadgeConfig(
              transaction.transactionType
            ).variant} size="md">
              {IndirectTaxTransactionHelper.getTransactionTypeBadgeConfig(
                transaction.transactionType
              ).label}
            </Badge>
          }
        />
        <StackedDataPoint
          label="Tax basis"
          value={<Badge variant='gray' size='md'>{isTaxIncluded ? 'Tax-inclusive' : 'Tax-exclusive'}</Badge>}
        />
        {showSupplyType && transaction.supplyType && (
          <StackedDataPoint
            label="Supply type"
            value={
              <Badge variant="gray" size="md">
                {IndirectTaxTransactionHelper.getSupplyTypeName(
                  transaction.supplyType
                )}
              </Badge>
            }
          />
        )}
        <StackedDataPoint
          label="Source"
          value={
            <Badge variant="gray" size="md">
              {transaction.source}
            </Badge>
          }
        />
        <StackedDataPoint
          label="Transaction currency"
          value={transaction.currency}
        />
        {/* Filing currency temporarily hidden
        <StackedDataPoint
          label="Filing currency"
          value={transaction.filingCurrency}
        /> */}

        {transaction.filings.length > 0 ? <StackedDataPoint label='Associated returns' value={<div className='flex flex-col gap-1'>
          {transaction.filings.map(eachFiling => <div className='flex gap-1'><span>{eachFiling.title}</span> <Badge variant={IndirectTaxFilingsHelper.getStatusBadgeConfig(eachFiling.status).variant}>{IndirectTaxFilingsHelper.getStatusBadgeConfig(eachFiling.status).label}</Badge></div>)}
        </div>} /> : null}
        {showConversionRate && transaction.conversionRate && (
          <StackedDataPoint
            label="Conversion rate"
            value={transaction.conversionRate.toString()}
          />
        )}
        <StackedDataPoint
          label="Origin address"
          value={transaction.originAddress ?? '–'}
        />
        <StackedDataPoint
          label="Destination address"
          value={transaction.destinationAddress}
        />
      </div>

      <Separator />

      <IndirectTaxTransactionCustomerSection
        customerName={transaction.customer?.name}
        customerEmail={transaction.customer?.email}
        onViewCustomer={onViewCustomer}
      />
    </div>
  );
};

export { IndirectTaxTransactionDetailSidebar };
